import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { CheckIcon, WrenchIcon } from '@heroicons/react/24/outline';
const McpToolsDropdown = ({ tools, selectedTools, onToolSelect, onClose, serverName })=>{
    const dropdownRef = useRef(null);
    useEffect(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        onClose
    ]);
    const isSelected = (tool)=>{
        return selectedTools.some((t)=>t.name === tool.name);
    };
    return /*#__PURE__*/ _jsxs("div", {
        ref: dropdownRef,
        className: "absolute bottom-full left-0 mb-2 w-80 rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800 z-50",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "border-b border-gray-200 px-4 py-3 dark:border-gray-700",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(WrenchIcon, {
                                className: "size-4 text-blue-600 dark:text-blue-400"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "text-sm font-medium text-gray-900 dark:text-gray-100",
                                children: "MCP Tools"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "mt-1 text-xs text-gray-500 dark:text-gray-400",
                        children: [
                            "From: ",
                            serverName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "max-h-64 overflow-y-auto",
                children: tools.length === 0 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-4 py-6 text-center text-sm text-gray-500 dark:text-gray-400",
                    children: "No tools available"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "py-2",
                    children: tools.map((tool)=>/*#__PURE__*/ _jsx("button", {
                            onClick: ()=>onToolSelect(tool),
                            className: "w-full px-4 py-2 text-left hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-start gap-3",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-shrink-0 mt-0.5",
                                        children: isSelected(tool) ? /*#__PURE__*/ _jsx("div", {
                                            className: "flex h-4 w-4 items-center justify-center rounded bg-blue-600 text-white",
                                            children: /*#__PURE__*/ _jsx(CheckIcon, {
                                                className: "size-3"
                                            })
                                        }) : /*#__PURE__*/ _jsx("div", {
                                            className: "h-4 w-4 rounded border border-gray-300 dark:border-gray-600"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-1 min-w-0",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-sm font-medium text-gray-900 dark:text-gray-100",
                                                        children: tool.name
                                                    }),
                                                    tool.inputSchema?.required && tool.inputSchema.required.length > 0 && /*#__PURE__*/ _jsx("span", {
                                                        className: "text-xs text-orange-600 dark:text-orange-400",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            tool.description && /*#__PURE__*/ _jsx("p", {
                                                className: "mt-1 text-xs text-gray-500 dark:text-gray-400 line-clamp-2",
                                                children: tool.description
                                            }),
                                            tool.inputSchema?.properties && /*#__PURE__*/ _jsxs("div", {
                                                className: "mt-1 flex flex-wrap gap-1",
                                                children: [
                                                    Object.keys(tool.inputSchema.properties).slice(0, 3).map((param)=>/*#__PURE__*/ _jsx("span", {
                                                            className: "inline-flex items-center rounded bg-gray-100 px-1.5 py-0.5 text-xs text-gray-600 dark:bg-gray-700 dark:text-gray-300",
                                                            children: param
                                                        }, param)),
                                                    Object.keys(tool.inputSchema.properties).length > 3 && /*#__PURE__*/ _jsxs("span", {
                                                        className: "text-xs text-gray-400",
                                                        children: [
                                                            "+",
                                                            Object.keys(tool.inputSchema.properties).length - 3,
                                                            " more"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, tool.name))
                })
            }),
            selectedTools.length > 0 && /*#__PURE__*/ _jsx("div", {
                className: "border-t border-gray-200 px-4 py-2 dark:border-gray-700",
                children: /*#__PURE__*/ _jsxs("p", {
                    className: "text-xs text-gray-500 dark:text-gray-400",
                    children: [
                        selectedTools.length,
                        " tool",
                        selectedTools.length !== 1 ? 's' : '',
                        " selected"
                    ]
                })
            })
        ]
    });
};
export default McpToolsDropdown;
